module.exports = __webpack_public_path__ + "img/small-mes.47afc82c.svg";